import { useContext } from 'react';

import { AuthStrategyContext } from './AuthStrategyContext';
import { AUTH_STRATEGY_NOT_READY_MESSAGE } from './constants';
import { EmbedStrategyProvider } from './EmbedStrategyProvider';
import { OtpStrategyProvider } from './OtpStrategyProvider';
import { RedirectStrategyProvider } from './RedirectStrategyProvider';
import type { AuthStrategyContextValue, AuthStrategyProviderProps } from './types';

// gloss
const loadingContext: AuthStrategyContextValue = {
  strategy: null,
  handleAuth: () => Promise.reject(new Error(AUTH_STRATEGY_NOT_READY_MESSAGE)),
};

// gloss
export const AuthStrategyProvider = ({ children, strategy }: AuthStrategyProviderProps) => {
  const parentContext = useContext(AuthStrategyContext);
  if (parentContext) return <>{children}</>;

  if (!strategy) {
    return <AuthStrategyContext.Provider value={loadingContext}>{children}</AuthStrategyContext.Provider>;
  }

  switch (strategy.type) {
    case 'otp':
      return <OtpStrategyProvider strategy={strategy}>{children}</OtpStrategyProvider>;
    case 'embed':
      return <EmbedStrategyProvider strategy={strategy}>{children}</EmbedStrategyProvider>;
    case 'redirect':
      return <RedirectStrategyProvider strategy={strategy}>{children}</RedirectStrategyProvider>;
  }
};
